import {
  Flyout_ImageContainer,
  Flyout_ImageContainer_FlyoutSection,
} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/navigation/v1/navigation_bar.types';
import {
  mediaDesktopAndUp,
  mediaTabletAndDown,
  mediaTabletAndUp,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {ImageSection} from './ImageSection';

export const ImageSectionsContainer: React.FC<Flyout_ImageContainer> = ({
  sections,
}) => {
  const SectionWrapper = isDropsFlyout(sections)
    ? DropsWrapper
    : React.Fragment;

  const hasOnlyImageSections = doesFlyoutOnlyContainImageSections(sections);

  return (
    <SectionsContainer hasOnlyImageSections={hasOnlyImageSections}>
      {sections.map(({headline, items, footer}, index) => (
        <SectionWrapper key={`imageSection_${index}`}>
          <ImageSection headline={headline} items={items} footer={footer} />
        </SectionWrapper>
      ))}
    </SectionsContainer>
  );
};

const DropsWrapper = styled.div`
  display: flex;
  gap: 24px 70px;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  flex-wrap: wrap;

  @media ${mediaTabletAndDown} {
    max-width: 342px; // case of smaller Ipads
  }
  @media ${mediaTabletAndUp} {
    max-width: 352px; // case of bigger tablets
  }
  @media ${mediaDesktopAndUp} {
    max-width: unset;
  }
`;

// 'hasOnlyImageSections' was introduced since we want images to shrink for most cases
// but not for the Inspiration Flyout where we only have images which are already
// fitting the flyout pretty well.
// Switching everything to column would cause this flyout for example to be displayed in
// two rows.
const SectionsContainer = styled.div<{hasOnlyImageSections: boolean}>`
  display: flex;
  flex-direction: column;

  @media ${mediaDesktopAndUp} {
    flex-direction: ${props => (props.hasOnlyImageSections ? 'row' : 'column')};
  }
  gap: 32px;
`;

const isDropsFlyout = (sections: Flyout_ImageContainer_FlyoutSection[]) => {
  return sections[0]?.items?.[0]?.type?.$case === 'drops';
};

const doesFlyoutOnlyContainImageSections = (
  sections: Flyout_ImageContainer_FlyoutSection[],
) => {
  return sections.every(section => {
    return section.items.every(item => item.type?.$case === 'imageTeaser');
  });
};
